import React, { useEffect, useState } from 'react';
import "./scss/style.scss";
import logo from "assets/img/logo.png";
import { useHistory } from 'react-router';
import { AdminSide, AnalyticSide, TaskSideHoc, FolderSideHoc, SupervisorSide } from "components/layout/sidebar"
import { BASE_ROUTES } from 'utils';

export function Sidebar() {

    const history = useHistory();
    const [targetSider, setTargetSider] = useState();

    useEffect(() => {
        sideToBeRendered();
    }, [history.location.pathname])

    //PREDICT SUITABLE SIDE TO BE DISPLAYED
    const sideToBeRendered = () => {
        let currentPage = history.location.pathname.split('/')[0]
            ? history.location.pathname.split('/')[0]
            : history.location.pathname.split('/')[1];
        switch (`/${currentPage}`) {
            case `${BASE_ROUTES.FOLDERS_ROUTE}`:
                setTargetSider(<FolderSideHoc />);
                break;
            case `${BASE_ROUTES.TASKS_ROUTE}`:
                setTargetSider(<TaskSideHoc />);
                break;
            case `${BASE_ROUTES.ADMIN_ROUTE}`:
                setTargetSider(<AdminSide />);
                break;
            case `${BASE_ROUTES.ANALYTICS_ROUTE}`:
                setTargetSider(<AnalyticSide />);
                break;
            case `${BASE_ROUTES.SUPERVISION_ROUTE}`:
                setTargetSider(<SupervisorSide />);
                break;
            case `${BASE_ROUTES.ACCESS_DENIED}`:
                setTargetSider(<div className="mx-3 text-center">Access Denied!</div>);
                break;
            default:
                setTargetSider(<div className="mx-3">No content !</div>);
                break;
        }
    }

    return (
        <nav id="sidebar" className="active$">

            {/* HEADER */}
            <div className="mx-2 my-3">
                <a href="index"><img src={logo} height="40" alt="img" />
                    <small style={{ color: "white" }}> Ooredoo Omni Channel CS</small>
                </a>
            </div>

            {/* SIDER CONTENT */}
            <ul class="list-unstyled components mb-5 ">
                {targetSider}
            </ul>

            {/* FOOTER */}
            {/* <div className="footer">
                <small>
                    Copyright &copy; {new Date().getFullYear()} <br/>All rights reserved Ooredoo
                </small>
            </div> */}
        </nav>

    );
}

//sider parent label
export function SiderParentLabel(props) {
    return (
        <div className={`mx-2 mb-2 parent-item ${props.className}`} ><i className={props.icon} /> {props.label}</div>
    );
}